import { render, staticRenderFns } from "./DiskMe.vue?vue&type=template&id=5be3c73d&scoped=true"
import script from "./DiskMe.vue?vue&type=script&lang=js"
export * from "./DiskMe.vue?vue&type=script&lang=js"
import style0 from "./DiskMe.vue?vue&type=style&index=0&id=5be3c73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3c73d",
  null
  
)

export default component.exports